import { createRouter, createWebHistory } from 'vue-router';
import OperatorLogin from '@/components/OperatorLogin.vue';
import BasicConfig from '@/components/BasicConfig.vue';
import BasicConfigGeneral from '@/components/BasicConfigGeneral.vue';
import SubjectRegist from '@/components/SubjectRegist.vue';
import SelectMenu from '@/components/SelectMenu.vue';
import MeasureExplanation from '@/components/MeasureExplanation.vue';
import MeasureResult from '@/components/MeasureResult.vue';
import MeasureResultPDF from '@/components/MeasurePDF.vue';
import MeasureHistory from '@/components/MeasureHistory.vue';
import QuestionRegistration from '@/components/QuestionRegistration.vue';
import TermsOfService from '@/components/TermsOfService.vue';
import Store from '@/store/index.js'

import InspectionReport from '@/components/InspectionReport.vue';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'root',
            component: OperatorLogin,
            meta: { requiresAuth: false },
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: TermsOfService,
            meta: { requiresAuth: false },
        },
        {
            path: '/login',
            name: 'login',
            component: OperatorLogin,
            meta: { requiresAuth: false },
        },
        {
            path: '/setting/:operator_id',
            name: 'basicConfig',
            component: BasicConfig,
            meta: { requiresAuth: true },
        },
        {
            path: '/setting-general/:operator_id',
            name: 'basicConfigGeneral',
            component: BasicConfigGeneral,
            meta: { requiresAuth: true },
        },
        {
            path: '/subjects/:operator_id',
            name: 'subjectsRegist',
            component: SubjectRegist,
            meta: { requiresAuth: true },
        },
        {
            path: '/subjects/select/:operator_id',
            name: 'selectMenu',
            component: SelectMenu,
            meta: { requiresAuth: true },
        },
        {
            path: '/subjects/select/question/:operator_id/:measureWord',
            name: 'ofQuestionExplanation',
            component: QuestionRegistration,
            meta: { requiresAuth: true },
        },
        {
            path: '/subjects/select/explanation/:operator_id/:measureWord',
            name: 'explanation',
            component: MeasureExplanation,
            meta: { requiresAuth: true },
        },
        {
            path: '/subjects/select/result/:operator_id',
            name: 'result',
            component: MeasureResult,
            meta: { requiresAuth: true },
        },
        {
            path: '/subjects/select/result/pdf',
            name: 'resultPDF',
            component: MeasureResultPDF,
            meta: { requiresAuth: true },
        },
        {
            path: '/history/:operator_id',
            name: 'history',
            component: MeasureHistory,
            meta: { requiresAuth: true },
        },
        {
            path: '/report/:operator_id',
            name: 'report',
            component: InspectionReport,
            meta: { requiresAuth: true },
        },
    ]
});

router.beforeEach((to, from) => { // eslint-disable-line
    if (to.meta.requiresAuth && !Store.state.dataManagement.isLogin) {
        return {
            name: "login",
            query: { redirect: to.fullPath },
        }
    }
    
    // Google Tag Manager page view tracking
    if (typeof window.dataLayer !== 'undefined' && window.dataLayer !== null) {
        window.dataLayer.push({
            'event': 'page_view',
            'page_path': to.fullPath,
            'page_title': to.name || 'Unknown Page'
        });
    }
})

export default router;
